import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class NastavnejedinicePopisService {

  constructor(private _http: Http) { }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_module', a)
    .map(res => res.json());
  }

  dohvatiNacinepradavanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_nacinepradavanja', a)
    .map(res => res.json());
  }

  dohvatiAktivnaPodrucjaznanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivna_podrucjaznanja', a)
    .map(res => res.json());
  }

  dodajNastavnuJedinicu(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_modul', a)
    .map(res => res.json());
  }

  urediModul(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_modul', a)
    .map(res => res.json());
  }

  obrisiNastavnuJedinicu(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'obrisi_modul', a)
    .map(res => res.json());
  }


}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/nastavnejedinice-popis/nastavnejedinice-popis.service.ts